import { render } from "./labresultreview.vue?vue&type=template&id=25842713&scoped=true"
import script from "./labresultreview.js?vue&type=script&lang=js"
export * from "./labresultreview.js?vue&type=script&lang=js"

import "./labresultreview.vue?vue&type=style&index=0&id=25842713&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25842713"]])

export default __exports__